import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApiClient} from "../../../tools/api-client";
import {FoundMeasurement} from "../found-measurement";
import {map} from "rxjs/operators";

import {recursiveNullToUndefined} from "../../../tools/recursive-null-to-undefined";
import {SelectedAnalyzer} from "../list-item";

export interface AssignTechnicianRequest {
  measurementId: number;
  technician: SelectedAnalyzer;
  patientDataLines: string[];
}

@Injectable()
export class AssignTechnicianService {

  constructor(private readonly apiClient: ApiClient) {
  }

  assign(
    request: AssignTechnicianRequest
  ): Observable<FoundMeasurement> {
    return this.apiClient.put<FoundMeasurement>(
      `/api/measurements/${request.measurementId}/technician`,
      {
        technician: request.technician,
        patientDataLines: request.patientDataLines
      }
    )
      .pipe(map(listItem => recursiveNullToUndefined(listItem)));
  }
}
